module.exports = __webpack_public_path__ + "img/box6-02.bffd2388.png";